// extracted by mini-css-extract-plugin
export default {"tabsContainer":"src-views-homepage-components-HomepageTabs-HomepageTabs__tabsContainer--OStol"};